<template>
  <div class="flex flex-col w-64 bg-white flex-no-shrink flex-no-grow border-solid border-r border-grey-lightest">
    <div class="flex relative flex-col pt-1 flex-no-shrink flex-no-grow border-solid border-t border-grey-lightest">
      <div class="flex flex-row h-12 text-xs items-center">
          <div @click="setActiveSection('request')" v-bind:class="[activeSection === 'request' ? 'font-semibold' : 'hover:text-blue hover:font-semibold']" class="w-1/3 text-grey-darkest text-center cursor-pointer">Request</div>
          <div @click="setActiveSection('completed')" v-bind:class="[activeSection === 'completed' ? 'font-semibold' : 'hover:text-blue hover:font-semibold']" class="w-1/3 text-grey-darkest text-center cursor-pointer">Completed</div>
          <div @click="setActiveSection('covid-new')" v-bind:class="[activeSection === 'covid-new' ? 'font-semibold' : 'hover:text-blue hover:font-semibold']" class="w-1/3 text-grey-darkest text-center cursor-pointer">COVID New</div>
      </div>
      <div class="flex flex-row h-1 bg-grey-lightest">
          <div class="w-1/3" v-bind:class="[activeSection === 'request' ? 'bg-blue' : '']"></div>
          <div class="w-1/3" v-bind:class="[activeSection === 'completed' ? 'bg-blue' : '']"> </div>
          <div class="w-1/3" v-bind:class="[activeSection === 'covid-new' ? 'bg-blue' : '']"> </div>
      </div>
      <!-- <div v-if="activeOfflineConsults.length>0" class="absolute text-xs bg-green text-white flex flex-row justify-center items-center" style="top: 0rem; left: 1.5rem; width: 2rem; height: 1rem; border-bottom-left-radius: 50%; border-bottom-right-radius: 50%;"> 
        {{activeOfflineConsults.length}} 
      </div>
      <div v-if="pastOfflineConsults.length>0" class="absolute text-xs bg-grey-lighter text-white flex flex-row justify-center items-center" style="top: 0rem; left: 7rem; width: 2rem; height: 1rem; border-bottom-left-radius: 50%; border-bottom-right-radius: 50%;">
        {{totalPastConsults}}
      </div>   -->
    </div>
    <!--Connected Components -->
    <div class = "overflow-auto" v-if="activeSection === 'request'">
      <div v-if="data.length === 0">
        <span class="text-sm flex justify-center my-4">No request Patients</span>
      </div>
      <div v-else>
        <div v-for="(item, index) in data" :key="index" @click="selectFromList(item)" 
          v-bind:class="(item.id === selectedPatient.id) ? 'bg-grey-extralight' : ''" 
          class="flex flex-col px-3 px-3 py-4 flex-no-shrink flex-no-grow border-b border-solid border-grey-lightest cursor-pointer hover:bg-grey-extralight">
            <div class="flex flex-row justify-between mb-2 h-4">
              <div class="text-sm font-semibold text-grey-darkest capitalize">{{item.mobile_number ? item.mobile_number : item.id}}</div>
            </div>
        </div>
      </div>
    </div>
    <!--Past Consult Components -->
    <div class = "overflow-auto" v-if="activeSection === 'completed'" >
      <div v-if="data.length === 0">
        <span class="text-sm flex justify-center my-4">No Completed Consultations</span>
      </div>
      <div v-else>
        <div v-for="(item, index) in data" :key="index" @click="selectFromList(item)" 
          v-bind:class="(item.id === selectedPatient.id) ? 'bg-grey-extralight' : ''" 
          class="flex flex-col px-3 px-3 py-4 flex-no-shrink flex-no-grow border-b border-solid border-grey-lightest cursor-pointer hover:bg-grey-extralight">
            <div class="flex flex-row justify-between mb-2 h-4">
              <div class="text-sm font-semibold text-grey-darkest capitalize">{{item.mobile_number ? item.mobile_number : item.id}}</div>
            </div>
        </div>
      </div>
    </div>
    <!-- Covid new Tab-->
    <div class = "overflow-auto" v-if="activeSection === 'covid-new'" >
      <!-- Diplay item goes here if any -->
    </div>
  </div>
</template>

<script>
export default {
  props: ['data', 'selectedPatient'],
  data () {
    return {
      activeSection: 'request'
    }
  },
  computed: {
  },
  methods: {
    setActiveSection: function (section) {
      this.activeSection = section
      this.$emit('tabChange', this.activeSection)
    },
    selectFromList: function (item) {
      this.$emit('selectFromList', item)
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/COVID-19/LeftPane.vue